import React, { useState } from 'react';
import { TextField, Button, Typography, Box, Link } from '@mui/material';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from "react-router-dom";
import { Link as RouterLink } from 'react-router-dom';

export default function Login() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

// --- START: DYNAMIC API URL ---
let API_ORIGIN;

// local dev
if (window.location.hostname === 'localhost' || window.location.hostname.startsWith('192.168.1.')) {
  API_ORIGIN = 'http://192.168.1.237:3000';
}
// beta site
else if (window.location.hostname === 'beta.flightiq.app') {
  API_ORIGIN = 'https://flightiq.app';   // << force prod API
}
// prod site
else {
  API_ORIGIN = 'https://flightiq.app';
}

const LOGIN_API = `${API_ORIGIN}/authapi/user_login.php`;
// --- END: DYNAMIC API URL ---

  const handleLogin = async () => {
    setMessage('');
    try {
      const payload = {
        username,
        email: username,
        password
      };

      const res = await axios.post(
        LOGIN_API,
        payload,
        {
          withCredentials: true,
          headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
          },
          validateStatus: () => true
        }
      );

      if (res.status >= 200 && res.status < 300 && res.data?.success) {
        login(res.data.token);
        setMessage('Login successful!');
        setTimeout(() => { navigate("/"); }, 1000);
      } else {
        console.error("Login failed:", res.status, res.data);
        setMessage(res.data?.message || `Login failed (HTTP ${res.status})`);
      }
    } catch (err) {
      console.error("Login request error:", err);
      setMessage('Login failed');
    }
  };

  return (
    <Box sx={{ maxWidth: 400, mx: 'auto', mt: 8 }}>
      <Typography variant="h5" gutterBottom>
        Login
      </Typography>
      <TextField
        fullWidth
        label="Username or Email"
        margin="normal"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />
      <TextField
        fullWidth
        label="Password"
        type="password"
        margin="normal"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <Button
        fullWidth
        variant="contained"
        sx={{ mt: 2 }}
        onClick={handleLogin}
      >
        Login
      </Button>
	  <Box sx={{ mt: 2, textAlign: 'center' }}>
        <Link component={RouterLink} to="/reset-password" variant="body2">
          Forgot Password?
        </Link>
      </Box>
      {message && <Typography sx={{ mt: 2 }}>{message}</Typography>}
    </Box>
  );
}